import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-setup-peach-payments',
  templateUrl: './setup-peach-payments.component.html',
  styleUrls: ['./setup-peach-payments.component.scss']
})
export class SetupPeachPaymentsComponent implements OnInit {

  @Input() partner;
  
  constructor() { }

  ngOnInit() {
  }

}
